import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { NullValidationHandler, ValidationHandler } from 'angular-oauth2-oidc';
import { Mdb5AdaptedModule, MdbLoadingModule, MdbModalRef, MdbModalService, MdbPopoverModule } from 'mdb5-adapted';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { ClientSearchModule } from 'src/app/client-search/client-search.module';
import { HttpErrorInterceptor, TRACKREQ_ENABLED } from 'src/app/core/interceptors/http-error.interceptor';
import { BranchEmployersModule } from 'src/app/features/branch-employers/branch-employers.module';
import { MenusModule } from 'src/app/modules/menus/menus.module';
import { RatesAndFeesModule } from 'src/app/modules/rates-and-fees/rates-and-fees.module';
import { RegionsAdminModule } from 'src/app/modules/regions-admin/regions-admin.module';
import { environment } from 'src/environments/environment';

import { LMSSharedUiModule } from '@lmsSharedUI';

import { AppComponent } from './app.component';
import { AuthModule } from './core/auth/auth.module';
import { LMSDatePickerModule } from './core/constants/datepicker-adapter';
import { LoaderInterceptor } from './core/interceptors/loading.interceptor';
import { RoleInterceptor } from './core/interceptors/role.interceptor';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './core/interceptors/timeout.interceptor';
import { RestServicesModule } from './core/rest-services/rest-services.module';
import { AUTO_LOGOUT, AutoLogoutService } from './core/services/auto-logout.service';
import { _window, WINDOW } from './core/services/window.token';
import { LandingModule } from './landing/landing.module';
import { NavigationModule } from './navbar/navigation.module';
import { AnnouncementBannerComponent } from './shared/announcement-banner/announcement-banner.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { MainLayoutComponent } from './shared/components/main-layout/main-layout.component';
import { LMSDialogHandlerService } from './shared/lmsdialog-handler.service';
import { LoadingSpinModule } from './shared/loaders';
import { ApiloaderService } from './shared/loaders/apiloader/apiloader.service';

@NgModule({
  declarations: [ AppComponent, MainLayoutComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientXsrfModule,
    Mdb5AdaptedModule,
    MdbLoadingModule,
    LoadingSpinModule,
    AppRoutingModule,
    NavigationModule,
     //CachingModule,
    FormsModule,
    HeaderComponent,
    NgxPaginationModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
        registrationStrategy: 'registerWhenStable:10000',
        enabled: environment.serviceWorker,
    }),
    BackButtonDisableModule.forRoot(),
    RestServicesModule,
    LMSSharedUiModule,
    MdbPopoverModule,
    MdbLoadingModule,
    ToastrModule.forRoot({
        timeOut: 8000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        maxOpened: 5,
        autoDismiss: true,
        enableHtml: true,
        tapToDismiss: true
      }),
    AuthModule.forRoot(),
    BranchEmployersModule,
    RegionsAdminModule,
    // RegionalManagerModule,
    ClientSearchModule,
    RatesAndFeesModule,
    MenusModule,
    LMSDatePickerModule,
    ReactiveFormsModule,
    LandingModule,
    AnnouncementBannerComponent
],
  providers: [
    { provide: DEFAULT_TIMEOUT, useValue: 120000 },
    { provide: TRACKREQ_ENABLED, useValue: true },
    { provide: AUTO_LOGOUT, useValue: 420000 }, // 60000 * 7 = 7 minutes
    LMSDialogHandlerService,
    LoadingSpinModule,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      deps:[ApiloaderService],
      multi: true, // Allows multiple interceptors
    },

    // provideHttpClient(withInterceptorsFromDi(
    // )),
    { provide: HTTP_INTERCEPTORS, useClass: RoleInterceptor, multi: true },
    { provide: MdbModalRef, useExisting: MdbModalService, multi: true },
    AutoLogoutService,
    //{ provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'en-ZA' },
     // NOTE: for CodeFlow use NullValidationHandler
    { provide: ValidationHandler, useClass: NullValidationHandler },
    { provide: WINDOW, useFactory: _window }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
